import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { Admin } from '../api/admin'

interface AdminState {
  admin: Admin | null
  isAuthenticated: boolean
  isLoading: boolean

  setAdmin: (admin: Admin | null) => void
  setLoading: (loading: boolean) => void
  logout: () => void
}

export const useAdminStore = create<AdminState>()(
  persist(
    (set) => ({
      admin: null,
      isAuthenticated: false,
      isLoading: true,

      setAdmin: (admin) => set({
        admin,
        isAuthenticated: !!admin,
        isLoading: false
      }),

      setLoading: (isLoading) => set({ isLoading }),

      logout: () => set({
        admin: null,
        isAuthenticated: false,
        isLoading: false
      }),
    }),
    {
      name: 'admin-auth',
      partialize: (state) => ({
        admin: state.admin,
        isAuthenticated: state.isAuthenticated
      }),
    }
  )
)
